export { default } from './Pagination';


//////////////////
// WEBPACK FOOTER
// ../~/rc-pagination/es/index.js
// module id = 1283
// module chunks = 0